import { Service, inject } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';

/**
 * Avisos al usuario.
 *
 * Es una de las cinco partes en las que se rompe `HelperService` (ADR-006).
 *
 * Microcopia: decir **qué pasó**, no cuál fue el código. "El nodo no confirmó el
 * comando", no "Error 500".
 */
@Service()
export class NotificacionesService {
  private readonly snackBar = inject(MatSnackBar);

  private mostrar(mensaje: string, clase: string, ms: number): void {
    const config: MatSnackBarConfig = {
      duration: ms,
      panelClass: ['aviso', clase],
      horizontalPosition: 'right',
      verticalPosition: 'bottom',
    };
    this.snackBar.open(mensaje, 'Cerrar', config);
  }

  ok(mensaje: string): void {
    this.mostrar(mensaje, 'aviso-ok', 3000);
  }

  /**
   * Un "ok" con una acción al lado en vez de "Cerrar" ("Ver detalle"). Dura más
   * que el ok común: la acción tiene que dar tiempo a leerla y tocarla.
   */
  okConAccion(mensaje: string, accion: string, alTocar: () => void): void {
    const ref = this.snackBar.open(mensaje, accion, {
      duration: 6000,
      panelClass: ['aviso', 'aviso-ok'],
      horizontalPosition: 'right',
      verticalPosition: 'bottom',
    });
    ref.onAction().subscribe(alTocar);
  }

  /**
   * Un aviso informativo con una acción ("Actualizar", "Ver novedades"). Dura
   * más que los demás: no es urgente y la acción tiene que dar tiempo a tocarla.
   */
  infoConAccion(mensaje: string, accion: string, alTocar: () => void): void {
    const ref = this.snackBar.open(mensaje, accion, {
      duration: 10000,
      panelClass: ['aviso', 'aviso-info'],
      horizontalPosition: 'right',
      verticalPosition: 'bottom',
    });
    ref.onAction().subscribe(alTocar);
  }

  aviso(mensaje: string): void {
    this.mostrar(mensaje, 'aviso-atencion', 5000);
  }

  /** Los errores duran más: el usuario tiene que poder leerlos. */
  error(mensaje: string): void {
    this.mostrar(mensaje, 'aviso-error', 8000);
  }

  info(mensaje: string): void {
    this.mostrar(mensaje, 'aviso-info', 4000);
  }
}
